__turbopack_context__.v({
  "card": "authCardShell-module-scss-module__ZLxa4a__card",
  "choiceButtons": "authCardShell-module-scss-module__ZLxa4a__choiceButtons",
  "content": "authCardShell-module-scss-module__ZLxa4a__content",
  "copyright": "authCardShell-module-scss-module__ZLxa4a__copyright",
  "divider": "authCardShell-module-scss-module__ZLxa4a__divider",
  "footerLinks": "authCardShell-module-scss-module__ZLxa4a__footerLinks",
  "footerText": "authCardShell-module-scss-module__ZLxa4a__footerText",
  "form": "authCardShell-module-scss-module__ZLxa4a__form",
  "formActions": "authCardShell-module-scss-module__ZLxa4a__formActions",
  "formField": "authCardShell-module-scss-module__ZLxa4a__formField",
  "fullWidthButton": "authCardShell-module-scss-module__ZLxa4a__fullWidthButton",
  "link": "authCardShell-module-scss-module__ZLxa4a__link",
  "logo": "authCardShell-module-scss-module__ZLxa4a__logo",
  "logoLink": "authCardShell-module-scss-module__ZLxa4a__logoLink",
  "message": "authCardShell-module-scss-module__ZLxa4a__message",
  "messageError": "authCardShell-module-scss-module__ZLxa4a__messageError",
  "messageSuccess": "authCardShell-module-scss-module__ZLxa4a__messageSuccess",
  "proudlyCanadian": "authCardShell-module-scss-module__ZLxa4a__proudlyCanadian",
  "rightLinkRow": "authCardShell-module-scss-module__ZLxa4a__rightLinkRow",
  "shell": "authCardShell-module-scss-module__ZLxa4a__shell",
  "smsConsent": "authCardShell-module-scss-module__ZLxa4a__smsConsent",
  "subtitle": "authCardShell-module-scss-module__ZLxa4a__subtitle",
  "title": "authCardShell-module-scss-module__ZLxa4a__title",
});
